import { Reveal } from "./Reveal";
import { Check, Cog, ChevronRight } from "lucide-react";

const youOwn = [
  "The trucking company",
  "The operating authority",
  "The truck or equipment",
  "The operating bank account",
  "The insurance policy",
  "The company's revenue",
];

const weOperate = [
  "Dispatch",
  "Driver coordination",
  "Compliance management",
  "Settlement reconciliation",
  "Operational reporting",
  "Back-office coordination",
];

export const Comparison = () => {
  return (
    <section id="model" data-testid="model-section" className="bg-[#050505] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <Reveal>
          <p className="font-display text-sm font-semibold uppercase tracking-[0.3em] text-orange-500 mb-6" data-testid="model-eyebrow">
            The Model
          </p>
          <h2
            className="font-display text-4xl md:text-5xl font-bold uppercase tracking-tight leading-[1.05] text-white"
            data-testid="model-headline"
          >
            You Own It. <span className="text-orange-500">We Operate It.</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-5 gap-6 items-stretch">
          <Reveal className="md:col-span-3">
            <div
              data-testid="model-own-card"
              className="relative h-full border-2 border-orange-500 bg-[#121212] p-8 md:p-10"
            >
              <span className="absolute -top-3.5 left-8 bg-orange-500 px-3 py-1 font-display text-xs font-bold uppercase tracking-[0.2em] text-white">
                Your Asset
              </span>
              <h3 className="font-display text-3xl md:text-4xl font-bold uppercase tracking-tight text-white">
                You Own
              </h3>
              <ul className="mt-8 grid sm:grid-cols-2 gap-x-8 gap-y-5">
                {youOwn.map((item, i) => (
                  <li key={item} data-testid={`own-item-${i}`} className="flex items-start gap-3 text-base md:text-lg font-medium text-white">
                    <Check size={20} className="mt-1 shrink-0 text-orange-500" strokeWidth={3} />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.15} className="md:col-span-2">
            <div
              data-testid="model-operate-card"
              className="h-full border border-neutral-800 bg-[#0D0D0D] p-8"
            >
              <h3 className="font-display text-2xl font-bold uppercase tracking-tight text-neutral-300">
                I Stay Trucking Operates
              </h3>
              <ul className="mt-8 space-y-4">
                {weOperate.map((item, i) => (
                  <li key={item} data-testid={`operate-item-${i}`} className="flex items-start gap-3 text-sm md:text-base text-neutral-400">
                    <Cog size={18} className="mt-0.5 shrink-0 text-orange-500" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.25}>
          <div className="mt-14 flex flex-col md:flex-row md:items-center gap-8 md:gap-12">
            <p
              className="border-l-4 border-orange-500 pl-6 font-display text-xl md:text-2xl font-semibold uppercase tracking-wide text-white max-w-2xl"
              data-testid="model-closing"
            >
              This isn't buying into someone else's trucking company. You're building your own.
            </p>
            <a
              href="#get-started"
              data-testid="model-cta"
              className="inline-flex shrink-0 items-center gap-2 border border-neutral-500 px-8 py-4 font-display text-base font-semibold uppercase tracking-wider text-white transition-all duration-200 hover:border-orange-500 hover:text-orange-500 hover:-translate-y-1"
            >
              See If You Qualify
              <ChevronRight size={18} />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
